// extracted by mini-css-extract-plugin
export default {"root":"GoToUserButton_root__vxi1p"};